import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import classes from "./pages.module.scss";
import classNames from "classnames";
import { connect, useSelector } from "react-redux";

import { PAGES } from "../constants/pages";
import SimplifiedPDFViewer from "./simplified-pdf-viewer";
import Header from "../components/header";
import { Button, Result } from "antd";
import { PDFCO_APP_URL, VERSION } from "../constants/common";
import { isNil } from "ramda";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoins } from "@fortawesome/free-solid-svg-icons";
import { selectRemainingCredits } from "../reducers/app/selectors";

function Pages() {
  const user = null;
  const remainingCredits = useSelector(selectRemainingCredits);

  const publicPages = [
    {
      path: PAGES.PDF_EDIT_ADD_HELPER.path,
      component: SimplifiedPDFViewer,
      exact: true,
    },
  ];

  return (
    <div className={classNames(classes.Wrap, "no-select")}>
      <Header />

      <Switch>
        {publicPages.map((props) => (
          <Route key={props.path} {...props} />
        ))}

        <Route exact path="/">
          <Redirect to={PAGES.PDF_EDIT_ADD_HELPER.path} />
        </Route>

        <Route>
          <Result
            className={classes.ResultWrap}
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={
              <Button type="primary" href={PDFCO_APP_URL}>
                Back Home
              </Button>
            }
          />
        </Route>
      </Switch>
      <div className={classes.Footer}>
        <div className={classNames(classes.RemainingCreditsWrap, "text-muted")}>
          {!isNil(remainingCredits) && (
            <a
              href="https://app.pdf.co/subscriptions"
              target="_blank"
              className="text-muted"
            >
              <span className={classes.Title}>
                <FontAwesomeIcon icon={faCoins} className={classes.Icon} />
                Remaining Credits:{" "}
              </span>
              <span className={classes.Value}>
                {remainingCredits.toLocaleString("en-US")}
              </span>
            </a>
          )}
        </div>
        <div>
          To see API calls details, press{" "}
          <span className="text-primary fw-bold mx-lg-1">Ctrl+Shift+J </span>
          to show Developer Console
        </div>
        <div className="text-muted">v.{VERSION}</div>
      </div>
    </div>
  );
}

const mapStateToProps = function () {
  return {};
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Pages);
